<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="flex-1 px-4 py-4 text-sm align-top">
      <RouterLink
        v-if="order.can.view"
        :to="{
          name: 'accounts.orders.show',
          params: { accountId: order.customer.id, orderId: order.uuid },
        }"
      >
        {{ order.name }}
      </RouterLink>
      <span v-else>{{ order.name }}</span>
      <br />
      <span class="text-gray-700">{{ order.supplier.name }}</span>
      <br />
      <ul class="flex -mx-1 flex-wrap">
        <li v-for="tag in order.tags" :key="tag.id" class="p-1">
          <BaseBadge
            custom
            :style="{
              backgroundColor: tag.customProperties.background,
              color: tag.customProperties.color,
            }"
            class="whitespace-nowrap"
          >
            {{ tag.name }}
          </BaseBadge>
        </li>
      </ul>
    </td>
    <td class="w-48 px-4 py-4 text-sm text-right align-top">
      <BaseBadge silver>
        {{ order.status.name }}
      </BaseBadge>
    </td>
    <td class="w-32 px-4 py-4 text-sm text-right align-top">
      <BaseBadge v-if="order.projectsCount" green> In project </BaseBadge>
    </td>
    <td class="w-32 px-4 py-4 text-sm text-right align-top">
      <BaseBadge v-if="order.invoice" green> Has Invoice </BaseBadge>
    </td>
    <td class="w-32 px-4 py-4 text-sm text-right align-top">{{ order.price }} &euro;</td>
    <td class="w-32 px-4 py-4 text-sm text-right align-top">
      {{ order.deliveryAtForHumans }}
    </td>
    <td class="w-32 px-4 py-4 text-sm text-right align-top">
      {{ order.createdAtForHumans }}
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
};
</script>
